export default "__VITE_ASSET__tUWHS_rJ__"